import { useQuery } from '@tanstack/react-query';

import { LocationKey } from './keys';
import { LocationService } from './locationService';

export function useGetLocations() {
  return useQuery({
    queryKey: [LocationKey.LOCATIONS],
    queryFn: () => LocationService.getLocations().then((response) => response.data),
  });
}
